export default "__VITE_ASSET__EfDf5hOP__"